import React from 'react';

export const RequiredAsterisk = () => <span style={{ color: 'red' }}>&nbsp;*</span>;
